<template>
  <div>
    <router-view @error="handleError" @toast="showToast" />
    <ErrorModal ref="errorModal" modal-id="error-modal" />
    <CToaster placement="top-end">
      <CToast
        :key="index"
        v-for="(toast, index) in toasts"
        :color="toast.color ? toast.color : 'default'"
      >
        <CToastHeader closeButton>
          <span class="me-auto fw-bold">
            {{ toast.title }}
          </span>
        </CToastHeader>
        <CToastBody>
          {{ toast.content }}
        </CToastBody>
      </CToast>
    </CToaster>
  </div>
</template>

<style lang="scss">
// Import Main styles for this application
@import 'styles/style';
</style>

<script>
import ErrorModal from '@/views/modals/ErrorModal'

export default {
  components: {
    ErrorModal,
  },
  data() {
    return {
      toasts: [],
    }
  },
  methods: {
    handleError(err) {
      this.$refs.errorModal.handle(err)
    },
    showToast(toast) {
      this.toasts.push(toast)
    },
  },
  mounted() {},
}
</script>
